import React from "react";
import HeroSearchForm2Mobile from "./HeroSearchForm2Mobile";
import HeroSearchForm2RealEstateMobile from "./HeroSearchForm2RealEstateMobile";
import { PathName } from "routers/types";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../images/logo.png";

const PAGES_REAL_ESTATE: PathName[] = [
  "/home-2",
  "/listing-real-estate",
  "/listing-real-estate-map",
];

const HeroSearchForm2MobileFactory = () => {
  const pathname = useLocation().pathname;
  if (pathname === "/") {
    <Link to="/">
        <img width={100} height={60} src={Logo}/>
      </Link>
    return <HeroSearchForm2Mobile />;
  }
  return (
    
    <div></div>
  ); // Or return a default component if none of the conditions match
};

export default HeroSearchForm2MobileFactory;
